var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_808_167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6743 2.35714C13.4865 0.214287 10.5171 0.214284 9.3293 2.35714L0.420971 18.4286C-0.766806 20.5714 0.717912 23.25 3.09347 23.25H20.9101C23.2857 23.25 24.7704 20.5714 23.5826 18.4286L14.6743 2.35714ZM12.0047 7.5C11.3315 7.5 10.8032 8.07727 10.8626 8.74784L11.432 15.1658C11.458 15.4591 11.7037 15.684 11.9982 15.684C12.2923 15.684 12.5378 15.4597 12.5644 15.1669L13.1465 8.75013C13.2074 8.07877 12.6788 7.5 12.0047 7.5ZM11.1315 19.1325C11.3735 19.3195 11.665 19.413 12.006 19.413C12.336 19.413 12.622 19.325 12.864 19.149C13.117 18.962 13.2435 18.632 13.2435 18.159C13.2435 17.686 13.117 17.3615 12.864 17.1855C12.622 17.0095 12.336 16.9215 12.006 16.9215C11.665 16.9215 11.3735 17.0095 11.1315 17.1855C10.8895 17.3615 10.7685 17.686 10.7685 18.159C10.7685 18.621 10.8895 18.9455 11.1315 19.1325Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_808_167)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FF2638"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFilled);
export default __webpack_public_path__ + "static/media/alert-filled.8860591f6e197f092c085cb30434a9fe.svg";
export { ForwardRef as ReactComponent };